<script lang="ts" setup>
import { ref,  computed, getCurrentInstance } from "vue";
import DxButton from "devextreme-vue/button";
import { DxPopup, DxPosition } from "devextreme-vue/popup";
import { useStore } from 'vuex'
import traducao from "@/localization/vistra.geral.json";
const instance = getCurrentInstance()!.appContext.config.globalProperties;
const { $http, $vistra } = instance;
$vistra.carregaTraducao([traducao]);
const store = useStore();
type Props = {
  title: string;
  labelButton: string;
};

type Emits = {
  cancel: () => void;
  confirm: () => void;
};
const icon = computed(() => store.state.tema == "tema" ? "light" : "dark");
const show = ref(false);

const toggle = () => {
  show.value = !show.value;
};

defineProps<Props>();
defineEmits<Emits>();
defineExpose({
  toggle,
});

</script>

<template>
  <DxPopup
    :title="title"
    :width="500"
    height="auto"
    container=".dx-viewport"
    :show-title="true"
    :drag-enabled="false"
    v-model:visible="show"
    :wrapper-attr="{ class: 'delete-popup' }"
    :show-close-button="true"
    :hide-on-outside-click="true"
  >
    <DxPosition at="center" my="center" />

    <div class="flex flex-col pt-4 pb-10 px-10">
      
      <img
        alt=""
        :src="`/assets/svgs/confirm-alert-${icon}.svg`"
        class="h-28"
      />
      <h3
        class="mt-6 text-center text-gray-900 dark:text-white !text-2xl !font-bold"
      >
        {{ title }}
      </h3>

      <p class="mt-1 text-center text-lg text-gray-500 dark:text-gray-300">
        {{$vistra.globalize('acao-pode-causar-erros-paineis')}}
      </p>

      <div class="flex mt-8 mx-auto items-center gap-6">
        <DxButton
          :text="$vistra.globalize('acao-cancelar')"
          type="normal"
          styling-mode="outlined"
          class="mr-2"
          @click="$emit('cancel')"
        />

        <DxButton :text="labelButton" type="danger" @click="$emit('confirm')" />
      </div>
    </div>
  </DxPopup>
</template>

<style lang="scss">
.delete-popup {
  @import '@/styles/base.scss';

  .dx-popup-content {
    @apply border-none #{!important};
  }

  .dx-popup-normal {
    .dx-popup-title.dx-has-close-button {
      @apply pb-0 pt-2 border-none;

      .dx-toolbar-items-container {
        .dx-toolbar-before {
          @apply hidden;
        }

        .dx-toolbar-after {
          @apply pl-0 #{!important};
          @apply w-[40px];
        }
      }
    }
  }
}
</style>
